export default {
      id: "icon-icontop3spare-usage",
      viewBox: "0 0 78 78",
      url: __webpack_public_path__ + "icons.svg#icon-icontop3spare",
      toString: function () {
        return this.url;
      }
    }